import { VISION_ID } from 'core/constants/products'

function getValidAddOnsByPlan(plan, addons = []) {
  // TODO: validate if id is vision
  return addons.filter(
    idToLook =>
      idToLook === VISION_ID || (plan && plan.addOnPlanIds.some(id => id === idToLook))
  )
}

export default getValidAddOnsByPlan
